import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/service/auth.service";
import { ChatService } from "../../service/chat.service";
import { NotificationService } from "../../service/notification.service";

@Component({
  selector: "app-notify",
  templateUrl: "./notify.component.html",
  styleUrls: ["./notify.component.scss"],
})
export class NotifyComponent implements OnInit {
  @Output() openChat = new EventEmitter();

  public newNotityCount: number = 0;

  public notifyData: any;

  public setIntNotify: any;

  public user: any;

  constructor(
    private chatService: ChatService,
    public auth: AuthService,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    $("#notifyDiv").hide();
    this.user = this.auth.userValue;
    if (this.user.role == "admin") {
      this.getNotify();
      this.setIntervalFn();
    }
  }

  // capture outside click event
  @HostListener("document:mousedown", ["$event"]) onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      $("#notifyDiv").hide("slow");
    }
  }

  public getNotify() {
    this.notificationService.getNotification().subscribe(
      (res) => {
        let data: any = res;
        this.notifyData = data.enquiryChat;
        if (data.recordCount.newStatusCount) {
          if (this.newNotityCount < Number(data.recordCount.newStatusCount)) {
            this.toastr.info("Hi you have a notification", "Notification", {
              timeOut: 2000,
            });
          }
          this.newNotityCount = Number(data.recordCount.newStatusCount);
        } else {
          this.newNotityCount = 0;
        }
        $("#notifyDiv").hide();
      },
      (err) => {
      }
    );
  }

  private setIntervalFn() {
    this.setIntNotify = setInterval(() => {
      this.getNotify();
    }, 120000); // here 1000 milli sec = 1sec
  }

  public updateStatus(SSN) {
    let statusData = {
      SocialSecurityNumber: SSN,
      Status: 1,
    };
    this.chatService.statusUpdate(statusData).subscribe(
      (res) => {
        if (this.newNotityCount > 0) {
          this.newNotityCount = this.newNotityCount - 1;
        }
        this.getNotify();
      },
      (err) => {
      }
    );
  }

  showFn() {
    // if (this.newNotityCount > 0) {
    $("#notifyDiv").toggle("slow");
    // }
  }

  openChatFn(data) {
    this.openChat.emit(data);
    if (data.socialSecurityNumber) {
      this.updateStatus(data.socialSecurityNumber);
    }
  }

  ngOnDestroy() {
    if (this.setIntNotify) {
      clearInterval(this.setIntNotify);
    }
  }
}
